import React from 'react';
import {
  Box, Container, Stack, Alert, AlertTitle, Chip,
} from '@mui/material';
import {
  Link,
  decodeHTMLEntities,
  getFormattedDateShortMonthDDYYYY,
  replaceNewLine,
  ReviewCard,
  useReviews,
} from '@marageti/z4-lib';
import { useParams } from 'react-router-dom';
import { ReviewStatus } from '@marageti/z4-sdk/lib/travel';
import { getRatingNumber } from '../../../utils/helpers';

const View = () => {
  const { tripMatchId } = useParams<{ tripMatchId: string }>();
  const { reviews } = useReviews({
    searchItemId: tripMatchId,
    searchItemFieldName: 'tripMatchId',
  });

  if (reviews && reviews.length === 0) {
    return (
      <Container maxWidth="md">
        <Alert severity="info">
          <AlertTitle>
            This trip hasn&apos;t been reviewed yet
          </AlertTitle>
        </Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          py: {
            desktop: 6.5,
            mobile: 4,
          },
        }}
      >
        <Stack spacing={1.5}>
          {reviews && reviews.map((review) => (
            <Link
              key={review.id}
              to={`/reviews/${review.id}`}
              state={{ review }}
            >
              <ReviewCard
                title={review.status === ReviewStatus.ReviewStatusPending ? 'Draft' : replaceNewLine(decodeHTMLEntities(review.title)) || '-'}
                titleTypographyProps={{
                  fontStyle: review.status === ReviewStatus.ReviewStatusPending ? 'italic' : undefined,
                }}
                subtitle={`${review.travelerName} • ${getFormattedDateShortMonthDDYYYY(review.createdAt)}`}
                avatar={{ src: review.travelerAvatar, name: review.travelerName }}
                rating={getRatingNumber(review.rating)}
                chips={review.published ? (
                  <Chip
                    label="Published"
                    variant="filled"
                    size="small"
                    sx={{
                      backgroundColor: (theme) => theme.palette.common.green25,
                    }}
                  />
                ) : (
                  <Chip
                    variant="outlined"
                    label="Unpublished"
                    size="small"
                  />
                )}
              />
            </Link>
          ))}
        </Stack>
      </Box>
    </Container>
  );
};

export default View;
